const keyBy = require('lodash/keyBy')
const shipsyFetch = require('./fetch')
const {
  generatePurchaseOrder,
  generateSalesOrder,
  transformProducts,
  generateStockTransferOrder,
  generateReturnShipment } = require('../tools')

class ShipsyAdapter {
  constructor (shipsyApiConfigs = {}, fetch, logger, api) {
    if (!shipsyApiConfigs || !shipsyApiConfigs.apiKey) {
      // If no configs provided, skip
      return
    }
    this.logger = logger
    this._rawFetch = fetch
    this.apiToken = shipsyApiConfigs.apiKey
    this.api = api

    if (typeof fetch !== 'function') {
      throw new Error('fetch is expected as an argument')
    }
  }

  async getAuthedFetch () {
    // Build a fresh authed fetch with the current token
    if (!this.apiToken) {
      this.logger.warn('ShipsyAdapter: no api token provided')
    }
    return shipsyFetch({ token: this.apiToken, fetch: this._rawFetch, logger: this.logger })
  }

  async upsertProducts (products) {
    if (!Array.isArray(products)) products = [products]

    const centralWarehouses = await this.api.shipment.dataShipmentAdapter.getCentralWarehouses()

    const centralWarehousesByMarketCode = keyBy(centralWarehouses, 'productMarketCode')

    const transformedProducts = transformProducts(products, centralWarehousesByMarketCode)

    if (!transformedProducts.length) {
      this.logger.info('No products to upsert to Shipsy')
      return
    }

    const path = '/SKUMasterfromFS/306'

    const authedFetch = await this.getAuthedFetch()

    const batchSize = 100 // Shipsy has a batchsize limit of 100
    for (let i = 0; i < transformedProducts.length; i += batchSize) {
      const batch = transformedProducts.slice(i, i + batchSize)
      await authedFetch({
        path,
        body: batch,
        method: 'POST'
      })
    }
  }

  async createPurchaseOrder (order, locationUuidById) {
    const transformedOrder = generatePurchaseOrder(order, locationUuidById)
    const path = '/POfromFS/307'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedOrder,
      method: 'POST'
    })
  }

  async updatePurchaseOrder (order, locationUuidById) {
    const transformedOrder = generatePurchaseOrder(order, locationUuidById)
    const path = '/POfromFS/313'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedOrder,
      method: 'POST'
    })
  }

  async createSalesOrder (shipment, locationUuidById) {
    const transformedOrder = generateSalesOrder(shipment, locationUuidById)
    const path = '/SalesOrderfromFS/314'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedOrder,
      method: 'POST'
    })
  }

  async updateSalesOrder (shipment, locationUuidById) {
    const transformedOrder = generateSalesOrder(shipment, locationUuidById)
    const path = '/SalesOrderfromFS/315'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedOrder,
      method: 'POST'
    })
  }

  async createReturnShipment (shipment, locationById) {
    const transformedShipment = generateReturnShipment(shipment, locationById)
    const path = '/SalesReturnfromFS01/319'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedShipment,
      method: 'POST'
    })
  }

  async createStockTransferOrder (shipment, locationById) {
    const transformedShipment = generateStockTransferOrder(shipment, locationById)
    const path = '/STOfromFS/316'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedShipment,
      method: 'POST'
    })
  }

  async updateStockTransferOrder (shipment, locationById) {
    const transformedShipment = generateStockTransferOrder(shipment, locationById)
    const path = '/STOfromFS/317'

    const authedFetch = await this.getAuthedFetch()

    await authedFetch({
      path,
      body: transformedShipment,
      method: 'POST'
    })
  }
}

module.exports = ShipsyAdapter
